export default __webpack_public_path__ + "static/media/youtube.beb52f7e.svg";